import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorMessageService } from './http-error-message.service';
import { SUPRIMIR_DIALOGO_ERRO } from './http-context-tokens';

@Injectable({
	providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {

	constructor(
		private httpErrorMessageService: HttpErrorMessageService
	) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {	
		
		/*ME PARECE QUE NAO É MAIS NECESSÁRIO TBM this.localStorageSingletonService.recarregarCartSingleton(this.cartSingletonService);
			this.localStorageSingletonService.recarregarConfig(this.configService);
			
		if (this.configService == null || this.configService.ip == undefined || this.configService.porta == undefined) {
			this.localStorageSingletonService.recarregarConfig(this.configService);
		}				
		this.localStorageSingletonService.recarregarCliente(this.clienteSingletonService);
		*/						
		
		return next.handle(request).pipe(
			catchError((error: HttpErrorResponse) => {
				/*
				 * O diálogo é o comportamento padrão. Quem trata o próprio erro e tem
				 * fallback definido marca a requisição com SUPRIMIR_DIALOGO_ERRO — sem
				 * isso, o modal apareceria antes de o erro chegar ao catchError do chamador.
				 * O erro continua sendo repassado em todos os casos.
				 */
				if (!request.context.get(SUPRIMIR_DIALOGO_ERRO)) {
					this.httpErrorMessageService.openErrorMessageDialog(error);
				}
				return throwError(() => error);
			})
		);
	}
}